const VIEWS = {
    MENU_PRINCIPAL: 'MENU_PRINCIPAL',
    FAQ: 'FAQ',
    FAVORITOS: 'FAVORITOS',
    SOBRE: 'SOBRE',
}

export default VIEWS